import { render, staticRenderFns } from "./promoName.vue?vue&type=template&id=237dce9b"
import script from "./promoName.vue?vue&type=script&lang=js"
export * from "./promoName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237dce9b')) {
      api.createRecord('237dce9b', component.options)
    } else {
      api.reload('237dce9b', component.options)
    }
    module.hot.accept("./promoName.vue?vue&type=template&id=237dce9b", function () {
      api.rerender('237dce9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promo/components/promoName.vue"
export default component.exports